import { useContext } from "react";

import {
  AdminStructureOpenPitGeometryFormContext,
  type AdminStructureOpenPitGeometryFormContextValue,
} from "./adminStructureOpenPitGeometryForm.context.definition";

export const useAdminStructureOpenPitGeometryFormContext =
  (): AdminStructureOpenPitGeometryFormContextValue => {
    const context = useContext(AdminStructureOpenPitGeometryFormContext);
    if (!context) {
      throw new Error(
        "useAdminStructureOpenPitGeometryFormContext must be used within AdminStructureOpenPitGeometryFormProvider",
      );
    }
    return context;
  };

export const useOptionalAdminStructureOpenPitGeometryFormContext =
  (): AdminStructureOpenPitGeometryFormContextValue | null =>
    useContext(AdminStructureOpenPitGeometryFormContext);
